export default __webpack_public_path__ + "static/banner-tips-for-travelling-on-a-shoestring-c819a6886936fb3b282c630051b39170.jpg";